import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'pibean';

  selectedProductTheme = 'primary';
  productThemeColorList = [
    {
      color: 'primary',
      code: '#02b3e4'
    },
    {
      color: 'secondary',
      code: '#607D8B'
    },
    {
      color: 'success',
      code: '#02ccba'
    },
    {
      color: 'info',
      code: '#a951ed'
    },
    {
      color: 'dark',
      code: '#000'
    },
    {
      color: 'warning',
      code: '#FA7623'
    },
    {
      color: 'danger',
      code: '#ff5483'
    }
  ];

  setSelectedTheme(roleBrand) {
    this.selectedProductTheme = roleBrand;
  }
}
